module.exports = {
  async getUserSearchHistories(s) {
    const url = `${this.url}/${this.version}/user/search_histories`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/user_search_history_api.js